import callApi from './personnelService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/member`;

export const getMemberDetail = (memberId) => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-member-detail/${memberId}`
});

export const updateMemberNoteName = (updateInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/update-member-note-name/${updateInfo.memberId}`,
  body: updateInfo
});

export const updateMemberDesc = (updateInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/update-member-desc/${updateInfo.memberId}`,
  body: updateInfo
});
export const getMemberCouponByID = (memberId) => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-member-coupons/${memberId}`,
})